import axios from 'axios';

// Base URL for your Node.js server
const SERVER_BASE_URL = 'https://new-patient-paperwork.uk.r.appspot.com/';  // Adjust as necessary

// Salesforce token is no longer needed in React
var newRecordId;

// Clean field name utility function
const cleanFieldName = (fieldName) => {
  return fieldName.replace(/^HQ_|__c$|__s$/g, '');
};

// Function to get the fields list from your Node.js server
const getFieldsList = async (objectName, fieldPrefix) => {
  const response = await axios.get(`${SERVER_BASE_URL}/api/salesforce/fields`, {
    params: {
      objectName,
      fieldPrefix,
    },
  });

  const { cleanedFields, originalFields } = response.data;
  return { cleanedFields, originalFields };
};

// Function to get account fields list from your Node.js server
const getAccountFieldsList = async (objectName, fieldPrefix) => {
  const response = await axios.get(`${SERVER_BASE_URL}/api/salesforce/account-fields`, {
    params: {
      objectName,
      fieldPrefix,
    },
  });

  const { accountFields, cleanedFields } = response.data;
 // console.log(accountFields);
  return { accountFields, cleanedFields };
};

// Function to get account info from your Node.js server
const getAccountInfo = async (id) => {
  try {
    const response = await axios.get(`${SERVER_BASE_URL}/api/salesforce/account/${id}`);
    return response;
    
  } catch (error) {
    console.error('Error getting record:', error.response);
    return false;
  }
};

// Function to fetch data for records from your Node.js server
const fetchDataForRecords = async (records) => {
  try {
    const response = await axios.post(`${SERVER_BASE_URL}/salesforce/fetch-records`, { records });
    return response.data;
  } catch (error) {
    console.error("Error fetching data for records:", error);
    return null;
  }
};

// Function to get record info from your Node.js server
const getRecordInfo = async (id) => {
  try {
    const response = await axios.get(`${SERVER_BASE_URL}/api/salesforce/record-get/${id}`);
    console.log("data",response.data);
    return response.data;
  } catch (error) {
    console.error('Error getting record info:', error.response);
    return 1;
  }
  
};

// Function to post data to Salesforce through your Node.js server
const postToInsuranceSalesforce = async (data,language) => {
  try {
    const response = await axios.post(`${SERVER_BASE_URL}/api/salesforce/insurance`, {data:data,language:language});
    newRecordId = response.data.id;
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : error.message);
  }
};

// Function to update a record in Salesforce through your Node.js server
const updateRecordInSalesforce = async (recordID, updatedData, language) => {
  try {
    //console.log("clear salesforce.jsx")
    const response = await axios.patch(`${SERVER_BASE_URL}/api/salesforce/record/${recordID}`,{data:updatedData,language:language});
    return response.data;
  } catch (error) {
    console.error('Error updating record:', error.response);
    throw new Error('Failed to update record');
  }
};

// Function to update an account in Salesforce through your Node.js server
const updateAccountInSalesforce = async (AccountID, updatedData) => {
  try {
    const response = await axios.patch(`${SERVER_BASE_URL}/api/salesforce/account/${AccountID}`, updatedData);
    return response.data;
  } catch (error) {
    console.error('Error updating record:', error.response);
    throw new Error('Failed to update record');
  }
};

// Function to send PDF to Salesforce through your Node.js server
const sendToSalesforce = async (base64PDF, name, accountid) => {
  try {
    const response = await axios.post(`${SERVER_BASE_URL}/api/salesforce/pdf`, { base64PDF, name, accountid });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

// Function to send signature to Salesforce through your Node.js server
const sendToSalesforceSign = async (signatureData, signatureName, accountId) => {
  try {
    const response = await axios.post(`${SERVER_BASE_URL}/api/salesforce/signature`, { signatureData, signatureName, accountId });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

// Function to fetch form data from your Node.js server
const fetchFormData = async () => {
  try {
    const response = await axios.get(`${SERVER_BASE_URL}/forms/1`);
    return response.data;
  } catch (error) {
    console.error('Error retrieving form data:', error);
    return null;
  }
};

// Function to post form data to your Node.js server
const posttoDatabase = async (formString) => {
  try {
    const response = await axios.post(`${SERVER_BASE_URL}/save-form`, formString);
    //console.log('Form submitted successfully');
  } catch (error) {
    console.error('Error submitting form:', error);
  }
};

export { getFieldsList, getAccountFieldsList, postToInsuranceSalesforce, updateRecordInSalesforce, getAccountInfo, getRecordInfo, sendToSalesforce, fetchFormData, posttoDatabase, updateAccountInSalesforce, sendToSalesforceSign };
